import PropTypes from "prop-types";

export const _Label = {
  className: PropTypes.string,
  isSmall: PropTypes.bool,
  text: PropTypes.string,
};

export const LabelPropTypes = _Label;
